import React from 'react'

interface HighlightedLevelInfoProps {
  highlightedLevel: string
  propertyCount: number
}

function HighlightedLevelInfo({
  highlightedLevel,
  propertyCount,
}: HighlightedLevelInfoProps) {
  return (
    <div className="flex min-w-[196px] flex-col rounded-[20px] bg-[#202020]/50 p-6 text-white">
      <span className="text-[28px] font-bold leading-[33.6px]">
        {highlightedLevel.trim()}
      </span>
      <span className="text-2xl font-medium leading-[28.8px]">{`${propertyCount} ${
        propertyCount > 1 ? 'Properties' : 'Property'
      }`}</span>
    </div>
  )
}

export default HighlightedLevelInfo
